export const MasteryStatus = {
  Mastered: "Mastered",
  NeedsWork: "Needs Work",
  Stuck: "Stuck",
  NotStarted: "Not Started",
  InProgress: "In progress",
  Exempt: "Exempt",
  Complete: "Complete",
};

const StatusMap = new Map();
StatusMap.set("MASTERED", MasteryStatus.Mastered);
StatusMap.set("IN PROGRESS", MasteryStatus.InProgress);
StatusMap.set("WHEEL SPINNING", MasteryStatus.Stuck);
StatusMap.set("NOT ATTEMPTED", MasteryStatus.NotStarted);
StatusMap.set("COMPLETE", MasteryStatus.Complete);

const StatusIconMap = new Map();
StatusIconMap.set(MasteryStatus.Mastered, "fa-light fa-medal");
StatusIconMap.set(MasteryStatus.Complete, "fa-solid fa-circle-check");
StatusIconMap.set(MasteryStatus.InProgress, "fa-light fa-person-running");
StatusIconMap.set(MasteryStatus.Stuck, "fa-light fa-hand");
StatusIconMap.set(MasteryStatus.Exempt, "fa-regular fa-ban");

const OverviewIconMap = new Map();
OverviewIconMap.set(MasteryStatus.Mastered, "fa-regular fa-circle-check");
OverviewIconMap.set(MasteryStatus.Complete, "fa-regular fa-circle-check");
OverviewIconMap.set(MasteryStatus.InProgress, "fa-light fa-person-running");
OverviewIconMap.set(MasteryStatus.Stuck, "fa-light fa-hand");
OverviewIconMap.set(MasteryStatus.Exempt, "fa-regular fa-ban");

export function getStatusValue(insightStatus) {
  if (!insightStatus) return undefined;
  return StatusMap.get(insightStatus.toUpperCase());
}

export function getStatusIcon(status) {
  return StatusIconMap.get(status);
}

export function getOverviewIcon(status) {
  return OverviewIconMap.get(status);
}

export function getAllStatus() {
  return [...StatusMap.values()];
}
